import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  CPP_AmenitiesAndFacilitiesFullWrapper: {
    height: '100%',
    minHeight: '560px',
    display: 'flex',
    backgroundColor: theme.palette.background.primary,
    padding: '20px 32px',
    flexDirection: 'column',
    gap: '20px',
  },
  CPP_AmenitiesAndFacilitiesInnerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  itemWrapper: {
    display: 'flex',
    gap: '32px',
    alignItems: 'center',
    '& > *:nth-child(1)': {
      height: '20px',
      width: '100%',
      maxWidth: '280px',
    },
    '& > *:nth-child(2)': {
      height: '44px',
      width: '100%',
      maxWidth: '512px',
    },
  },
}));
